import { html } from 'lit';

export const logo = (orgName: string, logoUrl?: string) => {
	return logoUrl
		? html`
				<div class="s-bg p-16 rounded-t-8">
					<img class="mx-auto max-h-[76]" src="${logoUrl}" alt="${orgName}" />
				</div>
			`
		: null;
};
